import { render } from "./PortalTopComponent.vue?vue&type=template&id=7bb1faf6&scoped=true&ts=true"
import script from "./PortalTopComponent.vue?vue&type=script&lang=ts"
export * from "./PortalTopComponent.vue?vue&type=script&lang=ts"

import "./PortalTopComponent.vue?vue&type=style&index=0&id=7bb1faf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb1faf6"]])

export default __exports__